import React from 'react';
import { removeUnloadListener } from '../../utils/hooks/useWarningOnUnload';
import { LazyComponent } from '../LazyImportComponent';
import getLoginModal from './getLoginModal';

const LazyLoginModalView = ({
    appleLoginUrl,
    defaultEmail,
    facebookLoginUrl,
    googleLoginUrl,
    onCloseLoginModal,
    onSignInSuccess,
    returnUrl,
    showRememberMe,
    __fakeImportLoginModal,
}) => {
    const LoginModal = __fakeImportLoginModal || getLoginModal();

    return (
        <LazyComponent componentName="LoginModal">
            <LoginModal
                facebookLoginUrl={facebookLoginUrl}
                googleLoginUrl={googleLoginUrl}
                appleLoginUrl={appleLoginUrl}
                onClickClose={onCloseLoginModal}
                onClickAppleLogin={removeUnloadListener}
                onClickFacebookLogin={removeUnloadListener}
                onClickGoogleLogin={removeUnloadListener}
                onSignInSuccess={onSignInSuccess}
                returnUrl={returnUrl}
                showRememberMe={Boolean(showRememberMe)}
                useDefaultRedirectAfterSignInSuccess={false}
                defaultEmailValue={defaultEmail}
            />
        </LazyComponent>
    );
};

export default LazyLoginModalView;
